import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  mainPaper:  {
    minWidth: 'fit-content'
  },
  titlePaper: {
    backgroundColor: theme.palette.primary.main,
    paddingLeft:     theme.spacing(3),
    paddingRight:    theme.spacing(3),
    paddingTop:      theme.spacing(2),
    paddingBottom:   theme.spacing(2),
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
  },
  title: {
    color: theme.palette.primary.contrastText,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '0.875rem',
  },
}));

export default useStyles;